import * as React from "react";
import {connect} from "react-redux";
import {userType} from "../../../mainReducerMapSelectors";
import {AdminLevelList, ConsultantLevelList, doesUserHaveAccess} from "../../model/UserDetails.model";
import {UserTypeEnum} from "../../model/UserInfo.model";
import {IApplicationRootState} from "../../../applicationState";
import {useNavigate} from "react-router-dom";
import {navigateTo} from "../../../navigateTo";
import {useEffect} from "react";

export interface IVerifyAccessPropsFromStore {
    userType: UserTypeEnum;
}

export interface IVerifyAccessProps {
    children?: React.ReactNode;
    accessLevel: UserTypeEnum;
}

export type VerifyAccessProps = IVerifyAccessProps & IVerifyAccessPropsFromStore;

export const VerifyAccessComponent: React.FunctionComponent<VerifyAccessProps> = (props) => {
    const navigate = useNavigate();
    const [continueRender, setContinueRender] = React.useState<boolean>(false);

        useEffect(() => {
            const accessList = props.accessLevel === UserTypeEnum.ADMIN ? AdminLevelList : ConsultantLevelList;
            if (props.accessLevel === UserTypeEnum.CLIENT || doesUserHaveAccess(props.userType, accessList)) {
                setContinueRender(true);
            } else {
                setContinueRender(false);
                navigateTo("/home", navigate);
            }
        }, []);

    return continueRender ? <div>{props.children}</div> : null;
};

export const mapStateToProps = (state: IApplicationRootState): IVerifyAccessPropsFromStore => {
    return {
        userType: userType(state),
    };
};

const ConnectedComponent =
    connect<IVerifyAccessPropsFromStore, {}, {}, IApplicationRootState>(
        mapStateToProps,
    )(VerifyAccessComponent);

export const withVerifyAccess = <TPropsFromParent extends {}>
(Wrapped: React.FunctionComponent<TPropsFromParent> | React.ComponentClass<TPropsFromParent>,
 accessLevel: UserTypeEnum) =>
    (props: TPropsFromParent) => {
        return <ConnectedComponent accessLevel={accessLevel}>
            <Wrapped {...props}/>
        </ConnectedComponent>;
};
